import StudentHomework from '@/api/eschool/student-homework'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  homework_status_id: null,
  date_from: moment()
    .add(-2, 'Month')
    .format('DD-MM-YYYY'),
  date_to: moment()
    .add(1, 'Month')
    .format('DD-MM-YYYY')
}

export const getters = {
  getTotalByHomeworkStatus: state => ({ homework_status_id } = {}) => {
    if (homework_status_id !== undefined && state.resources !== undefined) {
      return state.resources.filter(
        h => h.homework_status_id == homework_status_id
      ).length
    }

    return 0
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_HOMEWORK_STATUS(state, value) {
    state.homework_status_id = value
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign({
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage,
      search: context.state.search,
      date_from: context.state.date_from,
      date_to: context.state.date_to,
      status: context.state.homework_status_id,
      ...attributes
    })
    return StudentHomework.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  }
}
